import { useDispatch, useSelector } from 'react-redux';
import { emailSendModalSelectors } from '@/ModalWindows/EmailSendModal/services/selectors';
import { useEmailSendModalActions } from '@/ModalWindows/EmailSendModal/hooks/useEmailSendModalActions';
import { AppDispatch } from '@/Redux/ConfigureStore';
import { emailSendModalActions, SendEmailStep } from '@/ModalWindows/EmailSendModal/services/reducer';

export const useSelectDocumentModal = () => {
  const dispatch: AppDispatch = useDispatch();

  const selectedNumbers = useSelector(emailSendModalSelectors.selectedNumbers);

  const { sendExistingDocuments } = useEmailSendModalActions();

  const backPreviousStep = () => {
    dispatch(emailSendModalActions.setSendEmailStep(SendEmailStep.SelectTemplate));
  };

  const sendSelected = () => {
    sendExistingDocuments(selectedNumbers);
  };

  return {
    sendSelected,
    backPreviousStep,
  };
};
